var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('router-view'),_c('generic-notification'),_c('organization-basic-info-modal'),_c('new-version-available-notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }